import { useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar'
import { Badge } from '@/components/ui/badge'
import { Mail, Webhook, KeyRound } from 'lucide-react'

// PROJ-040: Release date for Email System feature
const EMAIL_SYSTEM_RELEASE_DATE = new Date('2025-12-05')
// PROJ-041: Release date for Webhook Management System
const WEBHOOK_SYSTEM_RELEASE_DATE = new Date('2025-12-09')
// PROJ-080: Release date for Credentials Management System
const CREDENTIALS_SYSTEM_RELEASE_DATE = new Date('2026-01-13')
const BADGE_DURATION_DAYS = 30

export default function SidebarTools() {
  const location = useLocation()

  // PROJ-040: Check if "New" badge should be shown for Email System
  const showEmailSystemBadge = useMemo(() => {
    const now = new Date()
    const expirationDate = new Date(EMAIL_SYSTEM_RELEASE_DATE)
    expirationDate.setDate(expirationDate.getDate() + BADGE_DURATION_DAYS)
    return now < expirationDate
  }, [])

  // PROJ-041: Check if "New" badge should be shown for Webhook System
  const showWebhookSystemBadge = useMemo(() => {
    const now = new Date()
    const expirationDate = new Date(WEBHOOK_SYSTEM_RELEASE_DATE)
    expirationDate.setDate(expirationDate.getDate() + BADGE_DURATION_DAYS)
    return now < expirationDate
  }, [])

  // PROJ-080: Check if "New" badge should be shown for Credentials System
  const showCredentialsSystemBadge = useMemo(() => {
    const now = new Date()
    const expirationDate = new Date(CREDENTIALS_SYSTEM_RELEASE_DATE)
    expirationDate.setDate(expirationDate.getDate() + BADGE_DURATION_DAYS)
    return now < expirationDate
  }, [])

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Herramientas</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton tooltip="Diagnósticos del Sistema" isActive={location.pathname === '/diagnostics'} asChild>
              <Link to="/diagnostics">
                <span>🩺</span>
                <span>Diagnostics</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          <SidebarMenuItem>
            <SidebarMenuButton tooltip="Documentación de APIs" isActive={location.pathname === '/apis'} asChild>
              <Link to="/apis">
                <span>🔌</span>
                <span>APIs</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          {/* PROJ-041: Webhook Management System */}
          <SidebarMenuItem>
            <SidebarMenuButton tooltip="Sistema de Webhooks - Inbound, Outbound, Visual Mapper" isActive={location.pathname === '/webhooks'} asChild>
              <Link to="/webhooks" className="flex items-center gap-2">
                <Webhook className="h-4 w-4" />
                <span>Webhooks</span>
                {showWebhookSystemBadge && (
                  <Badge variant="default" className="ml-auto text-[10px] px-1.5 py-0 h-4 bg-green-600 hover:bg-green-700">
                    New
                  </Badge>
                )}
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          {/* PROJ-080: Credentials Management System */}
          <SidebarMenuItem>
            <SidebarMenuButton tooltip="Credenciales - API Keys, OAuth2, Autenticación" isActive={location.pathname === '/credentials'} asChild>
              <Link to="/credentials" className="flex items-center gap-2">
                <KeyRound className="h-4 w-4" />
                <span>Credenciales</span>
                {showCredentialsSystemBadge && (
                  <Badge variant="default" className="ml-auto text-[10px] px-1.5 py-0 h-4 bg-green-600 hover:bg-green-700">
                    New
                  </Badge>
                )}
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          {/* PROJ-040: Email System */}
          <SidebarMenuItem>
            <SidebarMenuButton tooltip="Sistema de Email - Plantillas, Cola y Analíticas" isActive={location.pathname === '/email'} asChild>
              <Link to="/email" className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <span>Email</span>
                {showEmailSystemBadge && (
                  <Badge variant="default" className="ml-auto text-[10px] px-1.5 py-0 h-4 bg-green-600 hover:bg-green-700">
                    New
                  </Badge>
                )}
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          {/* PROJ-043: MCP Server Console */}
          <SidebarMenuItem>
            <SidebarMenuButton tooltip="MCP Server para asistentes de IA (Claude, Copilot)" isActive={location.pathname === '/mcp'} asChild>
              <Link to="/mcp">
                <span>🤖</span>
                <span>MCP Server</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
